export class BaseController {
  constructor(node) {
    this.node = node;
  }
  update() {
  }
  get material() {
    return this.node.material;
  }
}
